import {UpmEntityType, TreeNode} from '@hconnect/common/types'
import {Loader} from '@hconnect/uikit/src/lib2'

import {SignalDataType, SignalFormData} from '../../types/signal'

import {useCreateSignal} from './api/useCreateSignal'
import {useSignalOptions} from './hooks/useSignalOptions'
import {SignalForm} from './SignalForm'
import {getEquipmentPath} from './SignalForm.helpers'

interface NewSignalProps {
  selectedItem: TreeNode
  onCreated: (signalId: string) => void
  onGoBack: () => void
}

export const NewSignal: React.FC<NewSignalProps> = ({selectedItem, onCreated, onGoBack}) => {
  const {equipment, signalTypes, units, optionsLoading} = useSignalOptions()
  const {mutateAsync} = useCreateSignal((sensorId) => onCreated(sensorId))

  const signalEquipment =
    selectedItem.itemType === UpmEntityType.Equipment
      ? equipment?.find((equipment) => equipment.upmId === selectedItem.upmId)
      : null

  const defaultValues: SignalFormData = {
    localName: null,
    source: null,
    dataType: SignalDataType.RAW,
    name: '',
    type: null,
    unit: null,
    equipment: signalEquipment
      ? {
          id: signalEquipment.id,
          label: signalEquipment.text ?? 'Unknown',
          path: getEquipmentPath(signalEquipment)
        }
      : null,
    description: '',
    customThresholds: {
      high: null,
      highStatus: '',
      low: null,
      lowStatus: ''
    },
    modelConfidence: {
      value: null,
      status: ''
    },
    thresholds: {
      high: null,
      highHigh: null,
      low: null,
      lowLow: null,
      highStatus: '',
      lowStatus: '',
      highHighStatus: '',
      lowLowStatus: ''
    },
    timeToBreach: {
      high: '',
      highHigh: null,
      low: null,
      lowLow: null
    }
  }

  return optionsLoading ? (
    <Loader />
  ) : (
    <SignalForm
      defaultValues={defaultValues}
      equipment={equipment ?? []}
      units={units ?? []}
      onSubmit={mutateAsync}
      onGoBack={onGoBack}
      signalTypes={signalTypes ?? []}
      steppedSetup
    />
  )
}
